import init from "../../../../lib/common/js/init"
import components from "./components"
import dataStore from "./dataStore"
import { TrackingManager } from "../../../../lib/common/js/services/tracking/trackingManager"

init({
  components,
  dataStore,
})
